import "@/App.css";
import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";

import { AuthProvider } from "@/lib/auth";
import { SiteProvider } from "@/lib/site";

import AdminLogin from "@/admin/AdminLogin";
import AdminLayout from "@/admin/AdminLayout";
import CaseStudiesPage from "@/admin/CaseStudiesPage";
import CareersAdminPage from "@/admin/CareersPage";
import InvoicesPage from "@/admin/InvoicesPage";
import InvoiceSettingsPage from "@/admin/InvoiceSettingsPage";
import SiteCopyPage from "@/admin/SiteCopyPage";
import LegalAdminPage from "@/admin/LegalPage";
import Denied from "@/admin/Denied";

import Home from "@/pages/Home";
import ApproachPage from "@/pages/ApproachPage";
import AboutPage from "@/pages/AboutPage";
import CareersPage from "@/pages/CareersPage";
import ContactPage from "@/pages/ContactPage";
import PrivacyPolicy from "@/pages/PrivacyPolicy";
import Terms from "@/pages/Terms";
import CaseStudyPage from "@/pages/CaseStudyPage";
import InvoicePage from "@/pages/InvoicePage";

function RouterShell() {
    return (
        <Routes>
            <Route path="/" element={<Home />} />
            {/* Work lives on the homepage; only case-study detail gets its own URL */}
            <Route path="/work" element={<Navigate to="/#work" replace />} />
            <Route path="/work/:id" element={<CaseStudyPage />} />
            <Route path="/approach" element={<ApproachPage />} />
            <Route path="/about" element={<AboutPage />} />
            <Route path="/careers" element={<CareersPage />} />
            <Route path="/contact" element={<ContactPage />} />
            <Route path="/privacy" element={<PrivacyPolicy />} />
            <Route path="/terms" element={<Terms />} />

            {/* A client's invoice. Deliberately outside PageShell — it is a
                document, not a page of the site, so it carries no navigation
                and nothing that would print. The token is the only credential. */}
            <Route path="/i/:token" element={<InvoicePage />} />

            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin/denied" element={<Denied />} />
            <Route path="/admin" element={<AdminLayout />}>
                <Route index element={<CaseStudiesPage />} />
                {/* Kept so existing bookmarks still land somewhere useful. */}
                <Route
                    path="case-studies"
                    element={<Navigate to="/admin" replace />}
                />
                <Route path="careers" element={<CareersAdminPage />} />
                <Route path="invoices" element={<InvoicesPage />} />
                <Route
                    path="invoice-settings"
                    element={<InvoiceSettingsPage />}
                />
                <Route path="site" element={<SiteCopyPage />} />
                <Route path="legal" element={<LegalAdminPage />} />
            </Route>

            <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
    );
}

export default function App() {
    return (
        <BrowserRouter>
            <AuthProvider>
                <SiteProvider>
                    <RouterShell />
                </SiteProvider>
            </AuthProvider>
        </BrowserRouter>
    );
}
